import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import './plan.css'
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {Card,Radio,Checkbox,Collapse, Button,Form,Empty} from "antd/lib";
import { message,Spin,InputNumber,Skeleton,Switch} from "antd/lib";
import { selected_quote,ShortListQuote } from "../../Redux/actions/NumBikeation";
import { QuickQuoteHealth,ErrQuotesHealth,HealthQuestions} from "../../Redux/actions/NumHealth";
import { set_info1 } from "../../Redux/action";
import { TagOutlined,ShareAltOutlined,LoadingOutlined,DoubleRightOutlined } from '@ant-design/icons';
import { PremiumbreakupHealth } from "./PremiumBreakup";
import HealthComparePlan from "./HealthCompre";
import axiosInHealth from "../../Redux/axios/AxiosInHealth";
import ShorIcon from '../../assets/label_short.png'
import ShortedIcon from '../../assets/label_shortlist.png'
function Plan() {
    const Healthnum = useSelector((state) => state?.healthdetail?.healthnum);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
  const QQUpdatePost = useSelector((state) => state?.healthdetail?.quickQuotePost);
  const QQUpdateElect = useSelector((state) => state?.healthdetail?.quickQuotePost);
  const QuoteInput = useSelector((state) => state?.healthdetail?.quoteInput);
  const QQuoteData = useSelector((state) => state?.healthdetail?.quickquotes);
  const QQuoteErr = useSelector((state) => state?.healthdetail?.errquote);
  const SQQAddons = useSelector((state) => state?.common?.selectedAddons);
  const ShortLQQ = useSelector((state) => state?.common?.shortlist);

  const { Panel } = Collapse;
  const history = useHistory();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skullloading, setSkullloading] = useState(true);
  const [CompareQQ, setCompareQQ] = useState([]);
  const [PremiumData , setPremiumData] = useState('')

  useEffect(() => {
    dispatch(ErrQuotesHealth([])); 
    dispatch(HealthQuestions([]));
    // dispatch(set_info1({}))
    fetchData();
  }, []);
  console.log(QuotePost)
  const fetchData = () => {
    setSkullloading(true)
    setLoading(true)
    axiosInHealth
      .post(`v1/health_insurances/${Healthnum?.health_insurance_id}/quick_quotes`, QuotePost)
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          const data = res?.data?.data
          console.log(data)
          // console.log("data-----------------",data)
          const errData = data?.filter(item => ("status" in item && item?.status === "failed"));
          //dispatch(ErrQuotesHealth(errData));
    
          // const Breakin = data?.filter(item => ("motorBreakIn" in item && item?.motorBreakIn.isBreakin === true));
          // console.log('Breakin',Breakin)
          
        const filteredData = data?.filter(item => ("status" in item && item.status === "success"));
          const updatedData = filteredData?.map(item => ({
            ...item,
            selected: false
          }));
          console.log(updatedData)
          dispatch(QuickQuoteHealth(updatedData));
          setSkullloading(false)
          setLoading(false)
        } else {
          setSkullloading(false)
          setLoading(false)
          //console.log(res);
          message.error(res.data.error.validationMessages.join(","));
        }
      })
      .catch((err) => {
        console.log(err.response?.data);
        setSkullloading(false)
        setLoading(false)
        message.error(err?.response?.data?.message)
        if (err?.response?.data?.message == "Unauthenticated.") {
          message.error(
            err?.response?.data?.message + "Your access token has expired."
          );
          dispatch((dispatch) => {
            dispatch({ type: "RESET_CAR" });
            dispatch({ type: "RESET_BIKE" });
          });
          history.push("/");
        } else if (err?.response?.data) {
          //message.error(err.response.da)
        }
      })
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
        color: "#eb1b27"
      }}
      spin
    />
  );

  const handlePlan = (quote) => {
    //console.log('click quote',quote);
    dispatch(selected_quote(quote))
    history.push("/CustomerHealth");
  };

  const handleCheckboxChange = (index) => {
    const updatedQQuoteData = QQuoteData?.map((quote, i) => {
      if (i === index) {
        return { ...quote, compare: !quote.compare };
      }
      return quote;
    });
    const trueObjects = updatedQQuoteData.filter(quote => quote.compare);
    // console.log(trueObjects)
    setCompareQQ(trueObjects);
    dispatch(QuickQuoteHealth(updatedQQuoteData));
  };
//  const onShortList = (index)=> {
//   const updatedQQuoteData = QQuoteData?.map((quote, i) => {
//     if (i === index) {
//       return { ...quote,};
//     }
//     return quote;
//   });
//   //  const trueObjects = ShortLQQ.filter(quote => quote.insurer);
//   //  console.log(trueObjects)
//    dispatch(ShortListQuote(updatedQQuoteData))
//  }
const onShortList = (index) => {
  const updatedQQuoteData = QQuoteData.map((quote, i) => {
    if (i === index) {
      return { ...quote, selected: !quote.selected };
    }
    return quote;
  });
console.log(updatedQQuoteData)
dispatch(QuickQuoteHealth(updatedQQuoteData));
  dispatch(ShortListQuote(updatedQQuoteData));
}
const onClearList = ()=> {
  const updatedData = ShortLQQ?.map(item => ({
    ...item,
    selected: false
  }));
  dispatch(ShortListQuote([]));
  dispatch(QuickQuoteHealth(updatedData));
}
const handleOpen = (quote)=>{
  //console.log(quote)
  setPremiumData(quote)
  setShow(true);
}
const onGstChange = (checked)=> {
  console.log(checked)
  const updatedData = QQuoteData?.map(item => ({
    ...item,
    IsGst: checked
  }));
  console.log(updatedData)
  dispatch(QuickQuoteHealth(updatedData));
}
  return (
    <>
    <div className="hq-found">
        <div className="hq-inner">
    <div className="plan-card-head row align-items-center">
          <div className="col-xl-2">
            <span className="gst-sec">
              GST  
              {skullloading === false ? <>
                <Switch 
          defaultChecked
          checkedChildren="Yes" 
          unCheckedChildren="No" 
          onChange={onGstChange}
          />
              </> :  <Switch loading
          checkedChildren="Yes" 
          unCheckedChildren="No" 
          onChange={onGstChange}
          />}
          </span>
         
          </div>
          <div className="col-xl-2">
            {!skullloading && QQuoteData ? 
            <div className="quotelength">
              <p className="mb-0">{QQuoteData?.length}{' '}<span>Quotes Found</span></p>
            </div>
           : ''}
          </div>
        </div>
        </div>
        </div>
    <div className="site-card-wrapper-health">
      <div className="plan-health-wrap">
        <div className="planhealth-flex">
        {skullloading && QQuoteData?.length === 0 ? (
          <Card className="plan-card col-xl-4 col-lg-12 col-md-12 col-sm-12">
            <Skeleton active loading={skullloading} paragraph={{rows: 4, }}></Skeleton>
          </Card>
        ):null}
      
      {!skullloading && QQuoteData?.length === 0 ? ( 
        <div style={{padding: "30px"}}>
        <Empty description="No Quotes Found" />
        </div>
      ) : (
        <>
        {QQuoteData?.map((quote, index) => (
        <Card 
          key={index}
          className="plan-card-health"
        >
          <Skeleton active loading={skullloading} paragraph={{rows: 4, }}>
            <>
            <div className="plan-hfr-sec">
              <div className="shorlist-button">
            {quote.selected ? (
              <img src={ShortedIcon} onClick={() => onShortList(index)} />
            ) : (
              <img src={ShorIcon} onClick={() => onShortList(index)} />
            )}
          </div>
            <div className="hp-logo-sec">
            <div className="">
              <img className="qq-ins-logo" src={quote?.logo} alt="" />
            </div>
            </div>
            <div className="hp-logo-sec">
            <div>
            Sum Insured
            <p>₹{QuotePost?.suminsured}</p>
            </div>
            </div>
            <div className="hp-logo-sec text-center">
            <div>
            <Checkbox 
            checked={quote?.compare}
            onChange={() => handleCheckboxChange(index)}
            >Add to Compare
            </Checkbox>
            </div>
            {/* <div className="share-q-sec">
              Share Quote <span><ShareAltOutlined /></span>
            </div> */}
            </div>
            <div className="hp-logo-sec">
            <div className="text-center">
            <Button className="gross-txt-hlth" 
              onClick={()=>handlePlan(quote)}>
                {quote?.IsGst === true ? <>
                  ₹{" "}{typeof quote?.premium?.basePremiumWithTax === 'string' ? Math.round(parseFloat(quote?.premium?.basePremiumWithTax.replace(/[^\d.]/g, ""))) : quote?.premium?.basePremiumWithTax}
                  <p className="mb-0" style={{fontSize: "10px"}}>(Including GST)</p>
                </> : <>
                ₹{" "}{typeof quote?.premium?.basePremium === 'string' ? Math.round(parseFloat(quote?.premium?.basePremium.replace(/[^\d.]/g, ""))) : quote?.premium?.basePremium}
                  
                </>}
              </Button>
            </div>
            <div className="text-center">
              Cover{' '}
              {QuotePost?.suminsured === "300000" ? '₹ 3 Lakhs': 
                QuotePost?.suminsured === "500000" ? '₹ 5Lakhs': 
                QuotePost?.suminsured === '750000' ? '₹ 7.5 Lakhs':
                QuotePost?.suminsured === '1000000' ? '₹ 10 Lakhs':
                QuotePost?.suminsured === '1500000' ? '₹ 15 Lakhs': 
                QuotePost?.suminsured === '2000000' ? '₹ 20 Lakhs':
                QuotePost?.suminsured === '2500000' ? '₹ 25 Lakhs':
                QuotePost?.suminsured === '5000000' ? '₹ 50 Lakhs': 
                QuotePost?.suminsured === '7500000' ? '₹ 75 Lakhs':
                QuotePost?.suminsured === '10000000' ? '₹ 1 Crore': ''}
            </div>
            </div>
            </div>
            <div className="hp-logo-sec">
            {/* <div>
              Health Connect
            </div> */}
            <div>
            <p className="mb-0 d-flex" 
            // onClick={()=>handleOpen(quote)}
             style={{ color: "blue", cursor: "pointer", }}>
            View Features <span className="double-right"><DoubleRightOutlined /></span>
          </p>
            </div>
            </div>
          {/* {quote?.motorBreakIn?.isBreakin === true ? <p className="text-center text-danger">*Breakin Policy is under develop</p> : null}            */}
          </>
          </Skeleton>
        </Card>
        ))
      }
        </>
      )
       }
      </div>
      <div className="health-shortlist img-0">
        <div className="shortlist-inner">
            <div className="head-short">Shortlisted Plan(s)
            <span>{QQuoteData && QQuoteData?.some(quote => quote.selected) && QQuoteData?.length}</span>
            </div>
            {QQuoteData && QQuoteData?.some(quote => quote.selected) ? null :
              <p className="mt-2">Use <img src={ShorIcon} style={{width: "20px"}} alt="Shortlist icon" /> to Shortlist Plans</p>
            }
            {QQuoteData?.map((quote, index) => (
              <div key={index}>
                {quote?.selected === true && index === 0 && (
                  <div className="py-2">
                   <div className="d-flex gap-4">
                  <div className="shortlist-img">
                  <img src={quote?.logo}></img>
                  </div>
                  <div className="shorlisted-text">
                    <p>{quote?.insurer === 'go_digit' ? 'GoDigit Health Insurance' :null}</p>
                    <div className="d-flex justify-content-between">
                    <div>
                      <span>Cover</span>
                      <p> {QuotePost?.suminsured === "300000" ? '₹ 3 Lakhs': 
                      QuotePost?.suminsured === "500000" ? '₹ 5Lakhs': 
                      QuotePost?.suminsured === '750000' ? '₹ 7.5 Lakhs':
                      QuotePost?.suminsured === '1000000' ? '₹ 10 Lakhs':
                      QuotePost?.suminsured === '1500000' ? '₹ 15 Lakhs': 
                      QuotePost?.suminsured === '2000000' ? '₹ 20 Lakhs':
                      QuotePost?.suminsured === '2500000' ? '₹ 25 Lakhs':
                      QuotePost?.suminsured === '5000000' ? '₹ 50 Lakhs': 
                      QuotePost?.suminsured === '7500000' ? '₹ 75 Lakhs':
                      QuotePost?.suminsured === '10000000' ? '₹ 1 Crore': ''}</p>
                    </div>
                    <div>
                      <span>Premium</span>
                      <p>
                      ₹{" "}{typeof quote?.premium?.basePremiumWithTax === 'string' ? Math.round(parseFloat(quote?.premium?.basePremiumWithTax.replace(/[^\d.]/g, ""))) : quote?.premium?.basePremiumWithTax}
                        </p>
                    </div>
                    </div>
                  </div>
                </div>
                <div><Button type="primary" onClick={onClearList}>Clear</Button></div>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
       <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
       >
        <PremiumbreakupHealth quickQuote={PremiumData}/>
      </Modal>
     </div>
  </div>
  <div className="d-flex mt-3 justify-content-center">
    <div className={`${QQuoteErr?.length > 0 ? `bg-light errQ mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12` : `mt-3 px-3 py-3 col-xl-10 col-lg-12 col-md-12 col-sm-12`} `}>
      {!skullloading && (
        <>
          {QQuoteErr?.length > 0 && (
            <p className="err-q-txt">
              *We are not getting quote(s) from the following insurers. It might be possible reasons at the insurance company's
              end like MMV or RTO restricted or might be some technical issue.
            </p>
          )}
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {QQuoteErr?.map((quote, index) => (
              <div key={index} className="bg-white p-2 text-center col-xl-2">
                  <div className="qq-err-txt">
                <img style={{ width: "100px" }} src={quote?.logo} alt="" />
                  <p>{quote?.message}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      </div>
    </div>
  <div>
</div>
    {CompareQQ?.length > 0 ? <HealthComparePlan compareQQ={CompareQQ} setCompareQQ={setCompareQQ}/> : null}
    </>
  );
}

export { Plan };
